import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';

import { rootRouteRef } from './routes';

const ShieldIcon = () => (
  <svg
    aria-hidden="true"
    focusable="false"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    fill="currentColor"
  >
    <path d="M12 1 3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z" />
  </svg>
);

export const page = PageBlueprint.make({
  params: {
    path: '/sheriff-admin',
    routeRef: rootRouteRef,
    title: 'Admin',
    icon: <ShieldIcon />,
    loader: () =>
      import('./components/SheriffAdminPage').then(m => (
        <m.SheriffAdminPage />
      )),
  },
});

export const sheriffAdminPlugin = createFrontendPlugin({
  pluginId: 'sheriff-admin',
  extensions: [page],
  routes: {
    root: rootRouteRef,
  },
});
